import {ShopStreamItemV2_HighlightsSection_Highlight} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {
  TrackingPageTypeWithId,
  TrackingPromotionCreative,
} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  FONT_SIZES,
  ProductImage,
  Text,
  UnstyledLinkLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface BrandPageHighlightCardProps {
  streamPosition: number;
  highlight: ShopStreamItemV2_HighlightsSection_Highlight;
  // this is only used to improve the SEO
  targetUrl?: string;
  onClick?: VoidFunction;
}

export const BrandPageHighlightCard: React.FC<BrandPageHighlightCardProps> = ({
  streamPosition,
  highlight,
  targetUrl,
  onClick,
}) => {
  const onCardClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();
  };

  return (
    <StyledTrackPromotion
      trackingKey={`highlight-${highlight.highlightId}`}
      promotion={{
        source: TrackingPromotionCreative.Highlight,
        highlightId: highlight.highlightId,
        path: highlight.tracker.destination,
        promotionId: highlight.tracker.promotionId,
        promotionName: highlight.tracker.promotionName,
        trackHighlightIdAsPageId: false,
      }}
      pageType={TrackingPageTypeWithId.Brand}
      streamPosition={streamPosition}
      recoList={{
        sectionIndex: 0,
        recoType: 'brands_highlight',
        elements: [],
      }}
    >
      <Overlay
        onClick={onCardClick}
        to={targetUrl ?? ''}
        aria-label={undefined}
      />
      <ProductImage
        src={highlight.image.url}
        ratio={
          highlight.image.aspectRatio
            ? `${highlight.image.aspectRatio.width}:${highlight.image.aspectRatio.height}`
            : undefined
        }
      />
      <Label color="White">{highlight.title}</Label>
    </StyledTrackPromotion>
  );
};

const StyledTrackPromotion = styled(TrackPromotions)`
  position: relative;
  cursor: pointer;
  overflow: hidden;
`;

const Overlay = styled(UnstyledLinkLinaria)`
  position: absolute;
  inset: 0;
  background: linear-gradient(0, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 1;
  border-radius: 0 0 4px 4px;
`;

const Label = styled(Text)`
  position: absolute;
  bottom: 0;
  z-index: 2;
  width: 100%;
  padding: 8px;
  font-size: ${FONT_SIZES.px12};
  backdrop-filter: blur(1px);

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px14};
    padding: 14px;
  `)};
`;
